import { render, staticRenderFns } from "./TripsConfirm.vue?vue&type=template&id=2bc27387&"
import script from "./TripsConfirm.vue?vue&type=script&lang=js&"
export * from "./TripsConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports